import { defineStore } from 'pinia';
import { mergeOptionsParams, useCreateForm, useEditForm } from '@/stores/_helpers.js';
import toasteventbus from 'primevue/toasteventbus';

export const useCompanyRelationshipsStore = defineStore('companyRelationships', {
  state: () => ({
    data: undefined,
  }),
  getters: {
    getCompanyRelationships: (state) => state.data?.data,
  },
  actions: {
    async indexCompanyRelationships(params = {}) {
      try {
        const response = await axios.get('company-relationships', { params });
        this.data = response.data;
        return response.data;
      } catch (error) {
        console.error(error?.response || error);
        throw (error?.response || error);
      }
    },
    async createCompanyRelationship(params = {}) {
      try {
        const response = await axios.get('company-relationships/create', { params });
        return useCreateForm('company-relationships', response.data);
      } catch (error) {
        console.error(error?.response || error);
        throw (error?.response || error);
      }
    },
    async showCompanyRelationship(id, params = {}) {
      try {
        const response = await axios.get(`company-relationships/${id}`, { params });
        return response.data;
      } catch (error) {
        console.error(error?.response || error);
        throw (error?.response || error);
      }
    },
    async editCompanyRelationship(id, params = {}) {
      try {
        const response = await axios.get(`company-relationships/${id}/edit`, { params });
        return useEditForm(`company-relationships/${id}`, response.data);
      } catch (error) {
        console.error(error?.response || error);
        throw (error?.response || error);
      }
    },
    async deleteCompanyRelationship(id, params = {}) {
      try {
        await axios.delete(`company-relationships/${id}`, { params });
        toasteventbus.emit('add', {
          summary: 'Relationship Deleted',
          detail: 'Company relationship has been deleted.',
          severity: 'success',
          life: 3000,
        });
      } catch (error) {
        console.error(error?.response || error);
        throw (error?.response || error);
      }
    },
  },
});
